/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class i{constructor(i,o){this.position=i,this.rotationScale=o,this.origin=void 0}}export{i as Transform};
